import React, { useEffect, useState } from "react";
import { Table } from "antd";
import PropTypes from "prop-types";
import { API_BASE_URL } from "../Config/Config";
import Swal from "sweetalert2";
const Location = ({ record }) => {
  console.log(record, "record");

  const userData = JSON.parse(sessionStorage.getItem("HealthCheckuser"));
  console.log(userData, "userData");
  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
    },
    {
      title: "Address",
      dataIndex: "Address",
      key: "Address",
      render: (text) => text || "-",
    },
    {
      title: "Status",
      dataIndex: "IsActive",
      key: "IsActive",
      render: (isActive) => (
        <div className="d-flex align-items-center gap-2">
          <span
            style={{
              width: "15px",
              height: "15px",
              borderRadius: "50%",
              display: "inline-block",
              backgroundColor: isActive ? "#22c55e" : "#ef4444",
            }}
          />
        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, locationrecord) => (
        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="btn btn-sm btn-light border"
            onClick={() => handleEditLocation(locationrecord)}
          >
            <i className="ti ti-edit" />
          </button>
          {locationrecord?.IsActive === true && (
            <button
              type="button"
              className="btn btn-sm btn-light border"
              onClick={() => deleteLocation(locationrecord)}
            >
              <i className="ti ti-trash text-danger" />
            </button>
          )}
        </div>
      ),
    },
  ];

  const [locationData, setLocationData] = useState([]);
  console.log(locationData, "locationdata........");
  const [locationLoading, setLocationLoading] = useState(false);
  const [locationForm, setLocationForm] = useState({
    Id: 0,
    Name: "",
    Address: "",
  });

  const [isEdit, setIsEdit] = useState(false);

  const fetchLocations = async (superId) => {
    if (!superId) return;

    try {
      setLocationLoading(true);

      const res = await fetch(
        `${API_BASE_URL}api/org/getlocations?SuperId=${superId}`
      );

      const data = await res.json();

      if (data?.status && Array.isArray(data?.ResultData)) {
        setLocationData(data.ResultData);
      } else {
        setLocationData([]);
        console.error("Invalid response:", data);
      }
    } catch (error) {
      console.error("Fetch Locations Error:", error);
      setLocationData([]);
    } finally {
      setLocationLoading(false);
    }
  };

  useEffect(() => {
    if (record?.SuperId) {
      fetchLocations(record.SuperId);
    }
  }, [record]);

  const handleEditLocation = (locationrecord) => {
    setIsEdit(true);

    setLocationForm({
      Id: locationrecord?.Id || "",
      Name: locationrecord?.Name || "",
      Address: locationrecord?.Address || "",
    });
  };

  const updateLocation = async () => {
    try {
      const payload = {
        Id: locationForm?.Id,
        SuperId: record?.SuperId,
        UserId: userData?.[0]?.UserId,
        Name: locationForm?.Name,
        Address: locationForm?.Address,
      };

      console.log(payload, "Update Payload");

      const res = await fetch(`${API_BASE_URL}api/org/updatelocation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Location updated successfully",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchLocations(record?.SuperId);

        setLocationForm({
          Id: "",
          Name: "",
          Address: "",
        });

        setIsEdit(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: data?.message || "Failed to update location",
        });
      }
    } catch (error) {
      console.error("Update Location Error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
      });
    }
  };

  const addLocation = async () => {
    try {
      const payload = {
        Id: 0,
        SuperId: record?.SuperId,
        UserId: userData?.[0]?.UserId,
        Name: locationForm?.Name,
        Address: locationForm?.Address,
      };

      console.log(payload, "Add Payload");

      const res = await fetch(`${API_BASE_URL}api/org/addlocation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Location added successfully",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchLocations(record?.SuperId);

        setLocationForm({
          Id: 0,
          Name: "",
          Address: "",
        });

        setIsEdit(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Add Failed",
          text: data?.message || "Failed to add location",
        });
      }
    } catch (error) {
      console.error("Add Location Error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
      });
    }
  };

  const deleteLocation = async (locationRecord) => {
    try {
      const payload = {
        Id: locationRecord?.Id,
        SuperId: record?.SuperId,
        UserId: userData?.[0]?.UserId,
      };

      console.log(payload, "Delete Payload");

      const res = await fetch(`${API_BASE_URL}api/org/deletelocation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.status) {
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Location deleted successfully",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchLocations(record?.SuperId);
      } else {
        Swal.fire({
          icon: "error",
          title: "Delete Failed",
          text: data?.message || "Failed to delete location",
        });
      }
    } catch (error) {
      console.error("Delete Location Error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
      });
    }
  };

  const resetLocationForm = () => {
    setLocationForm({
      Id: 0,
      Name: "",
      Address: "",
    });

    setIsEdit(false);
  };

  return (
    <div className="modal fade" id="locationModal">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              Add New Locaton -
              <span style={{ color: "orange" }}>{record?.OrgName}</span>
            </h4>
            <button
              id="closeAddCompanyModal"
              type="button"
              className="btn-close custom-btn-close p-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetLocationForm}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            {/* Form Card */}
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Location Name <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          name="Name"
                          className="form-control"
                          placeholder="Enter Location Name"
                          value={locationForm.Name}
                          onChange={(e) =>
                            setLocationForm({
                              ...locationForm,
                              Name: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-8">
                      <div className="mb-3">
                        <label className="form-label">
                          Address <span className="text-danger">*</span>
                        </label>

                        <textarea
                          name="Address"
                          className="form-control"
                          placeholder="Enter Address"
                          rows={1}
                          value={locationForm.Address}
                          onChange={(e) =>
                            setLocationForm({
                              ...locationForm,
                              Address: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="d-flex justify-content-end mt-2">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                      onClick={resetLocationForm}
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={isEdit ? updateLocation : addLocation}
                    >
                      {isEdit ? "Update" : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* Table Card */}
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Location List</h5>
              </div>

              <div className="card-body p-2">
                <Table
                  columns={columns}
                  dataSource={locationData}
                  loading={locationLoading}
                  rowKey={(record) => record.Id}
                  pagination={{ pageSize: 5 }}
                  scroll={{ x: true }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Location.propTypes = {
  record: PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    OrgName: PropTypes.string,
    SuperId: PropTypes.number,
  }),
};

export default Location;
